import React from 'react';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import extend from 'lodash/extend';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';

import * as analytics from '../lib/analytics';
import HubSocialShare from './HubSocialShare';
import Modal from './Modal';

import styles from './confirmation.less';

import { ModalInputDiv, InputOverlay, InputOverlayMobileWidth } from './styles';

const ConfirmationModal = React.memo(
  ({ npid, npoUrl, fptiInfo, isMobile, subTitle, title, i18n, cdnHost }) => {
    new Clipboard('#clipBoardTrigger');

    const clickCopy = (event) => {
      analytics.trackLink(
        'overlaycopybutton',
        fptiInfo.pgrp,
        fptiInfo.page,
        'link'
      );
    };

    let inputOverlayStyle = '';

    if (isMobile) {
      inputOverlayStyle = extend({}, InputOverlay, InputOverlayMobileWidth);
    } else {
      inputOverlayStyle = extend({}, InputOverlay);
    }

    const clipBtnStyle = classNames('clipBtn', {
      clipBtnMobile: isMobile,
    });

    return (
      <Modal
        titleId={i18n('label.conf-title')}
        showOnMount={true}
        id={'campaignConfirmation'}
      >
        <>
          <div className={styles['confirmation-container']}>
            <img
              src={`https://${cdnHost}/webstatic/en_GB/mktg/ppc/icon-success.png`}
              alt='confirmpng'
              height='82'
              width='82'
            />
          </div>
          <input
            type={'hidden'}
            name={'npid'}
            value={npid}
            id={'nemo_conf_npid'}
          />
          <HeadingText
            as='h2'
            id={i18n('label.conf-title')}
            size='md'
            className={styles['center-text']}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          <BodyText
            as='p'
            size='md'
            className={`${styles['center-text']} ${styles['extra-margin']}`}
            dangerouslySetInnerHTML={{
              __html: subTitle,
            }}
          />
          <div style={{ textAlign: 'center' }}>
            <BodyText
              as='p'
              size='md'
              regular
              className={styles['social-invite-text']}
            >
              {i18n('label.conf-invite')}
            </BodyText>
            <div style={ModalInputDiv} className='modalInputDiv'>
              <input
                className='overlay_input'
                style={inputOverlayStyle}
                type='text'
                id='clipBoardTextInput'
                value={npoUrl}
              />
              <button
                href='#'
                id='clipBoardTrigger'
                className={clipBtnStyle}
                data-clipboard-target='#clipBoardTextInput'
                onClick={(e) => {
                  clickCopy(e);
                }}
              >
                {i18n('label.conf-copy-button')}
              </button>
            </div>
            <div style={{ marginTop: '20px' }}>
              <HubSocialShare
                url={npoUrl}
                fptiInfo={fptiInfo}
                i18n={i18n}
                cdnHost={cdnHost}
              />
            </div>
          </div>
        </>
      </Modal>
    );
  }
);

export default ConfirmationModal;
